import type { Collection } from 'state/utils/types';

export interface SecondaryRealtimePrice {
  bidUpfrontAndSalesMargin: number;
  askUpfrontAndSalesMargin: number;
  bidSettlementPrice: number;
  askSettlementPrice: number;
  unitSettlementPrice: string;
  referencePrice: {
    value: number;
    valueType: string;
  };

  salesMargin: number;
  extLimitTime: string;
  quoteStatus: boolean;
}
export type Trend = 'decrease' | 'increase' | 'stagnate';
export type TrackedValue = { value?: number; trend: Trend };

export type SecondaryRealtimePriceModel = Omit<SecondaryRealtimePrice, 'bidSettlementPrice' | 'askSettlementPrice'> & {
  bidSettlementPrice: TrackedValue;
  askSettlementPrice: TrackedValue;
};
export type RealtimePriceState = SecondaryRealtimePriceModel;

export type RealtimeMap = Collection<RealtimePriceState>;

export const initialRealtimeMap = {};
